import React, { useMemo } from 'react';
import styled from 'styled-components';
import Proptypes from 'prop-types';
import CheckIcon from './CheckIcon';
import themes from '../../../utils/themes';

export const StyledCheck = styled.span`
  height: ${(props) => (props?.size ? `${props?.size}px` : '20px')};
  width: ${(props) => (props?.size ? `${props?.size}px` : '20px')};
  border-radius: ${(props) => (props?.size ? `${props?.size / 3}px` : '6px')};
  min-width: ${(props) => (props?.size ? `${props?.size}px` : '20px')};
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  color: ${({ theme, iconColor }) =>
    iconColor ? theme[iconColor] : theme.white};
  transition: background-color 0.3s ease;
  background-color: ${({ theme, value, color, bgColor, disabled }) =>
    disabled
      ? theme.gray40
      : bgColor && value
      ? theme[bgColor]
      : color && value
      ? theme.mainPrimary
      : value
      ? theme.primary
      : themes.white};
  border: 2px solid
    ${({ theme, value, borderColor, disabled }) =>
      disabled
        ? 'transparent'
        : value
        ? theme.primary
        : theme[borderColor] ?? (value ? theme.primary : themes.inputBorder)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  svg {
    fill: ${({ theme, iconColor }) =>
      iconColor ? theme[iconColor] : 'currentColor'};
  }
`;

export const StyledRounded = styled.span`
  height: ${(props) => (props?.size ? `${props?.size}px` : '20px')};
  width: ${(props) => (props?.size ? `${props?.size}px` : '20px')};
  border-radius: 50%;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  color: ${themes.white};
  transition: background-color 0.3s ease;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.gray40 : theme.transparent};
  border: 2px solid
    ${({ theme, value, borderColor, bgColor, disabled }) =>
      disabled
        ? 'transparent'
        : bgColor && value
        ? theme[bgColor]
        : theme[borderColor] ?? (value ? theme.primary : themes.inputBorder)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  flex: 0 0 20px;

  .dot {
    padding: 6px;
    background-color: ${({ theme, value, color, bgColor, disabled }) =>
      disabled
        ? theme.gray40
        : bgColor && value
        ? theme[bgColor]
        : color && value
        ? theme.mainPrimary
        : value
        ? theme.primary
        : themes.white};
    border-radius: 50%;
  }
`;
const StyledCheckbox = ({
  value,
  name = '',
  color = '',
  onChange,
  label,
  disabled,
  size,
  labelClassName,
  rounded,
  ...props
}) => {
  const id = useMemo(() => `checkbox-${Math.random()}`, []);
  const onChangeCheckbox = (event) => {
    if (onChange) {
      onChange(event);
    }
  };
  return (
    <>
      <label
        htmlFor={id}
        className="d-flex align-items-center mb-0 mr-1 mr-sm-4 check-box"
        style={{ cursor: 'pointer' , marginRight : '0px' }}
      >
        {rounded ? (
          <StyledRounded
            value={value}
            name={name}
            color={color?.toString()}
            height={size}
            width={size}
            size={size}
            rounded={rounded}
            disabled={disabled}
            {...props}
          >
            <div className="dot" />
          </StyledRounded>
        ) : (
          <StyledCheck
            value={value}
            name={name}
            color={color?.toString()}
            height={size}
            width={size}
            size={size}
            disabled={disabled}
            borderColor={props?.borderColor}
            {...props}
          >
            {value && <CheckIcon size="10px" />}
          </StyledCheck>
        )}

        {label && (
          <span className={`ms-2 text-nowrap text-black ${labelClassName}`}>
            {label}
          </span>
        )}
      </label>
      <input
        id={id}
        type="checkbox"
        style={{ display: 'none' }}
        checked={value}
        disabled={disabled}
        onChange={onChangeCheckbox}
      />
    </>
  );
};

StyledCheckbox.propTypes = {
  value: Proptypes.bool,
  onChange: Proptypes.func,
  label: Proptypes.string,
};

export default StyledCheckbox;
